export const normalizeRoles = (role) =>
  Array.isArray(role) ? role.filter(Boolean) : role ? [role] : [];

export const hasRole = (user, ...allowed) =>
  normalizeRoles(user?.role).some((r) => allowed.includes(r));

export const formatDot = (value) => {
  return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const numberWithCommas = (data) => {
  let dataTemp =
    data &&
    data.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  return dataTemp;
};

export const switchDotsAndCommas = (s) => {
  function switcher(match) {
    return match === "," ? "." : ",";
  }
  return s && s.replaceAll(/\.|\,/g, switcher);
};

const angkaKeTerbilang = (angka) => {
  const satuan = [
    "",
    "satu",
    "dua",
    "tiga",
    "empat",
    "lima",
    "enam",
    "tujuh",
    "delapan",
    "sembilan",
    "sepuluh",
    "sebelas",
  ];

  const terbilang = (n) => {
    n = Math.floor(n);
    if (n < 12) {
      return satuan[n];
    } else if (n < 20) {
      return terbilang(n - 10) + " belas";
    } else if (n < 100) {
      return terbilang(Math.floor(n / 10)) + " puluh " + terbilang(n % 10);
    } else if (n < 200) {
      return "seratus " + terbilang(n - 100);
    } else if (n < 1000) {
      return terbilang(Math.floor(n / 100)) + " ratus " + terbilang(n % 100);
    } else if (n < 2000) {
      return "seribu " + terbilang(n - 1000);
    } else if (n < 1000000) {
      return terbilang(Math.floor(n / 1000)) + " ribu " + terbilang(n % 1000);
    } else if (n < 1000000000) {
      return (
        terbilang(Math.floor(n / 1000000)) + " juta " + terbilang(n % 1000000)
      );
    } else if (n < 1000000000000) {
      return (
        terbilang(Math.floor(n / 1000000000)) +
        " miliar " +
        terbilang(n % 1000000000)
      );
    } else {
      return (
        terbilang(Math.floor(n / 1000000000000)) +
        " triliun " +
        terbilang(n % 1000000000000)
      );
    }
  };

  // Bersihkan spasi ganda & trim
  return terbilang(angka).replace(/\s+/g, " ").trim();
};

export const formatRupiahTerbilang = (angka) => {
  const kata = angkaKeTerbilang(angka);
  return `(${kata} rupiah)`;
};

export const capitalizeSentences = (text) => {
  return text
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const hariList = [
  "Minggu",
  "Senin",
  "Selasa",
  "Rabu",
  "Kamis",
  "Jumat",
  "Sabtu",
];
const bulanList = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

function parseTanggal(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);
  const dateObj = new Date(year, month - 1, day);
  return { day, month, year, dateObj };
}

export const getNamaHari = (dateString) => {
  const { dateObj } = parseTanggal(dateString);
  return hariList[dateObj.getDay()];
};

export const getTanggalLengkap = (dateString) => {
  const { day, month, year } = parseTanggal(dateString);
  return `${String(day).padStart(2, "0")} ${bulanList[month - 1]} ${year}`;
};

export const formatJamKerja = (desimalJam, pemisah = ",") => {
  if (desimalJam === "" || isNaN(desimalJam)) return "";
  const jam = Math.floor(desimalJam);
  const menit = Math.round((desimalJam - jam) * 60);
  if (menit === 60) return `${jam + 1}${pemisah}00`;
  return `${jam}${pemisah}${String(menit).padStart(2, "0")}`;
};

export const parseJamKerja = (str, pemisah = ",") => {
  if (!str) return 0;
  const [jamStr, menitStr] = str.split(pemisah);
  const jam = parseInt(jamStr, 10) || 0;
  const menit = parseInt(menitStr, 10) || 0;
  return jam + menit / 60;
};
